const _modal = require("./_modal");
module.exports = {

    init: function()
    {
        this.activePage();
        this.hamburger();
        this.dropdown();
        this.compareSlider();
        this.packageSwitcher();
        this.fixedCompSlider();
        this.toTop();
        this.jumpToPageSection();
        this.detectScroll();
        this.openAccordion();
        this.jscounter();
        this.callRates();
        this.footerForm();
        this.complaintForm();
        this.troublePayingForm();
        this.cookieBar();
        this.showHiddenDials();
        this.loadChart();
        this.changeChart();
        this.autoScroll();
        this.reviewPopup();
        this.offersAlert();
        this.accordion();
        this.videoTabs();
        this.speedTabs();
        this.dropdownMenu()
        this.menuSearch();
        this.wholesaleForm();
        this.termsModals();

        if (this.isTouch()) $('body').addClass('supports-touch')

        $('[data-toggle="tooltip"]').tooltip({container: 'body'})

        $('.package, .package-item__button, .package-item button:not([data-toggle="modal"])').on('click', function(e){

            if ($(e.target).is("sup")) {
                return false
            }

            if ($(e.target).attr('data-toggle') == "tooltip") {
                return false;
            }

            APPLICATION.Home.selectPackage($(this));

            return false;

        });

        $('#add-voice-no-reason').not('.js-ignore').on('click', function(){
          $('#no-voice-wrapper').show()
        }).addClass('js-ignore');

        $('#no_voice_reason_id').not('.js-ignore').on('change', function(){
          if ('1' == $(this).val())
          {
            $('#no-voice-reason-wrapper').show()
          }
          else
          {
            $('#no-voice-reason-wrapper').hide()
          }
        }).addClass('js-ignore').trigger('change')

        $('#add-voice-no').not('.js-ignore').on('click', function(){
          $('input[name="package"]').val( '' );
          $('#choose-package-form').submit();
        }).addClass('js-ignore');

        // Counter replay button
        $('.dial-comparison__replay button').click(function() {

           APPLICATION.Global.jscounter();

        })

    },
    offersAlert: function() {

        var self = this

        if ($('.bottom-alert__close').length) {
            $('.bottom-alert__close').click(function(){
                $('.bottom-alert-wrapper').remove();
                self.createCookie('hide-offer-alert', '1', 1);  
            })
            $('.bottom-alert-wrapper').click(function(e){
                if (this == e.target) {
                    $('.bottom-alert-wrapper').remove();
                    self.createCookie('hide-offer-alert', '1', 1);  
                }
            })
        }

    },
    createCookie: function(name, value, days) {
        var date, expires;
        if (days) {
            date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";
    },
    autoScroll: function() {

        if(window.location.hash) {
          var target = $(window.location.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          console.log(target)
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            var offsetVal = window.innerWidth > 1025 ? 100 : 90;
            $('html, body').animate({
              scrollTop: target.offset().top - offsetVal
            }, 1000);
          }
        }

    },
    activePage: function() {

        $('.active-item').removeClass('active-item');

        var currentUrl = window.location.href;
        var end = currentUrl.split('/').pop();

        var currentMenuItem = $(".navigation-list ul a[href='/" + end + "']");

        currentMenuItem.addClass('active-item');

    },

    hamburger: function() {
        $('.c-hamburger').click(function(){

            $(this).toggleClass('is-active');
            $('body').toggleClass('menu-open');
            $(this).parent().attr('aria-expanded', $(this).hasClass('is-active'))

        });

        $('.hamburger-wrapper').on('keydown', function(e) {
            if (e.keyCode === 13) {
                $(this).toggleClass('is-active');
                $('body').toggleClass('menu-open');
                $(this).attr('aria-expanded', $(this).hasClass('is-active'))
            }
        })

        $('.menu-item-has-child span').click(function(){

            $(this).parent().toggleClass('is-active');

        });

        $('body').on('keydown', function(e){
            if (e.keyCode == 27) {
                $('.hamburger-wrapper').attr('aria-expanded', false)
                $('.c-hamburger').removeClass('is-active')
                $('body').removeClass('menu-open')
                $('html').removeClass('menu-search-active')
                $('.js-menu-search').attr('aria-expanded', 'false')
                $('.menu-search-results').html('')
            }
        })
    },
    dropdown: function() {

        $('.dropdown-button').click(function(){

            $(this).toggleClass('is-active');
            $('body').toggleClass('dropdown-open');

        });

    },

    compareSlider: function(){

        $("#range_02").ionRangeSlider({
            min: 1,
            max: 1000,
            from: 150,
            onChange: function (data) {

                if( data.from <= 285 ) {


                    $('.comp div:not([data-grade="light"])').removeClass('active');
                    $('.comp div[data-grade="light"]').addClass('active');

                    $('.comp-slider ul li a:not([data-grade="light"])').removeClass('active');
                    $('.comp-slider ul li a[data-grade="light"]').addClass('active');

                } else if ( data.from >= 285 && data.from <= 690 ) {

                    $('.comp div:not([data-grade="medium"])').removeClass('active');
                    $('.comp div[data-grade="medium"]').addClass('active');

                    $('.comp-slider ul li a:not([data-grade="medium"])').removeClass('active');
                    $('.comp-slider ul li a[data-grade="medium"]').addClass('active');

                } else if ( data.from >= 690 ){

                    $('.comp div:not([data-grade="super"])').removeClass('active');
                    $('.comp div[data-grade="super"]').addClass('active');

                    $('.comp-slider ul li a:not([data-grade="super"])').removeClass('active');
                    $('.comp-slider ul li a[data-grade="super"]').addClass('active');

                }

            },
        });

        var slider = $("#range_02").data("ionRangeSlider");

        $('.comp-slider li a').click(function(){

            $('.comp div:not([data-grade="' + $(this).attr("data-grade") +'"])').removeClass('active');
            $('.comp div[data-grade="' + $(this).attr("data-grade") +'"]').addClass('active');

            var from = 0;

            if ( $(this).attr("data-grade") == 'medium' ) {

                from = 500;

            } else if ( $(this).attr("data-grade") == 'super' ) {

                from = 800;

            }

            slider.update({

                from: from

            });

        });

    },

    packageSwitcher: function() {

        if ($('.home-homepage').length > 0) {


            $('.home').addClass('is-active');

            $('.home_fibre').show();
            $('.business_fibre').hide();

        } else {

            $('.business').addClass('is-active');

            $('.home_fibre').hide();
            $('.business_fibre').show();

        }

        $('.home').click(function() {
            $('.home').addClass('is-active');
            $('.business').removeClass('is-active');

            $('.home_fibre').show();
            $('.business_fibre').hide();
        });

        $('.business').click(function() {
            $('.business').addClass('is-active');
            $('.home').removeClass('is-active');

            $('.home_fibre').hide();
            $('.business_fibre').show();
        });


    },

    fixedCompSlider: function() {

        if ( $('.comp-slider-wrapper').length == 0 ) return

        $(window).scroll(function() {

            if ( $(window).width() > 1140) {

                $('.comp-slider-wrapper').css( 'padding-top', '0' );
                $('.comp-slider').removeClass('fixed-slider');

                return false;

            };

            var scrollTop     = $(window).scrollTop(),
                elementOffset = $('.comp-slider-wrapper').offset().top;
            bottomElementOffset = $('.contact-title').offset().top;

            if(scrollTop >= elementOffset - 64 && scrollTop <= bottomElementOffset - 186) {

                $('.comp-slider-wrapper').css( 'padding-top', $('.comp-slider').outerHeight() );
                $('.comp-slider').addClass('fixed-slider');

            } else {

                $('.comp-slider-wrapper').css( 'padding-top', '0' );
                $('.comp-slider').removeClass('fixed-slider');

            }

        });

    },

    toTop: function() {

        $('.to-top-button').on('click', function(){

            $("html, body").animate({ scrollTop: "0px" });

        });

    },


    jumpToPageSection: function() {

        // Select all links with hashes
        $('a[href*="#"]')
        // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function(event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - 64

                        }, 1000, function() {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            };

                        });

                    }

                }

            });

    },

    ScrollToDifferentPage: function() {

        var jump = function(e) {

            if (e){
                e.preventDefault();
                var target = $(this).attr("href");
            }else{
                var target = location.hash;
            }

            $('html,body').animate({

                scrollTop: $(target).offset().top

            }, 2000,function() {

                location.hash = target;
            });

        }

        $('html, body').hide();

        $(document).ready(function() {
            $('a[href^=#]').bind("click", jump);

            if (location.hash){
                setTimeout(function(){
                    $('html, body').scrollTop(0).show();
                    jump();
                }, 0);
            }else{
                $('html, body').show();
            }
        });

    },

    detectScroll: function() {

    },

    detectIE: function() {

      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    },

    jscounter: function() {

        let self = this;

        $('.js__counter').each(function(e) {

            // Remove previous counter
            $(this).find('svg, .progressbar-text').remove();

            // Remove 'started' class
            $(this).removeClass('started');

            let counter = $(this).attr('id'),
                duration = parseInt($(this).attr('duration')),
                seconds = parseFloat(duration / 1000);

            let bar = new ProgressBar.Circle('#' + counter, {
                color: '#fff',
                // This has to be the same size as the maximum width to
                // prevent clipping
                strokeWidth: self.detectIE() ? 6: 10,
                trailWidth: self.detectIE() ? 6: 10,
                easing: 'linear',
                duration: duration,
                text: {
                    autoStyleContainer: false
                },
                from: { color: '#26A9E0', width: self.detectIE() ? 6: 10 },
                to: { color: '#26A9E0', width: self.detectIE() ? 6: 10 },
                // Set default step function for all animate calls
                step: function(state, circle) {
                    circle.path.setAttribute('stroke', state.color);
                    circle.path.setAttribute('stroke-width', state.width);

                    var value = (circle.value() * seconds).toFixed(1);
                    if (value === 0) {
                        circle.setText('');
                    } else {
                        circle.setText(value + ' sec');
                    }

                }
            });

            bar.text.style.fontFamily = '"Raleway", Helvetica, sans-serif';
            bar.text.style.color = '#262261';
            bar.text.style.fontSize = '16px';
            bar.text.style.fontWeight = '600';

            bar.set(0);

            if ( $('#' + counter).hasClass('started') ) return;

            let el = $(this)

            setTimeout(function() {
                if ( self.checkDialsInViewport(el) ) {
                    bar.animate(1.0);
                    $('#' + counter).addClass('started')
                }
            }, 500);

            $(window).scroll(function() {

                if ( $('#' + counter).hasClass('started') ) return;

                setTimeout(function() {
                    if ( self.checkDialsInViewport(el) ) {
                        bar.animate(1.0);
                        $('#' + counter).addClass('started')
                    }
                }, 500);

            });


            $(window).resize(function() {

                if ( $('#' + counter).hasClass('started') ) return;

                if ( self.checkDialsInViewport(el) ) {
                    bar.animate(1.0);
                    $('#' + counter).addClass('started')
                }

            });

        });



    },

    checkDialsInViewport: function(el) {

        return $(el).isInViewport()

    },

    openAccordion: function() {

        $('.accordion-level__one').on('click', function(){

            $(this).toggleClass('closed');
            $(this).toggleClass('opened');

            $(this).closest('.accordion-item').find('.panel-level__one').toggleClass('closed');
            $(this).closest('.accordion-item').find('.panel-level__one').toggleClass('opened');

        });

        $('.accordion-level__two').on('click', function(){

            $(this).toggleClass('closed');
            $(this).toggleClass('opened');

            $(this).closest('.accordion-level__two__panel__item').find('.panel-level__two').toggleClass('closed');
            $(this).closest('.accordion-level__two__panel__item').find('.panel-level__two').toggleClass('opened');

        });

    },

    callRates: function() {

        let self = this;

        self.preloadInternationalCallsTab();

        $("#uk-calls-input").on('keypress', function (event) {

          var keycode = (event.keyCode ? event.keyCode : event.which);

          if(keycode == '13')
          {
            $('#uk-calls-container span').trigger('click');
          }

        });

        // UK Calls click event
        $('#uk-calls-container span').on('click', function (e) {

          e.preventDefault()

          if ($("#uk-calls-input").val() == '') {

            $('#uk-calls-container').next('div.uk-calls-fees').empty();

            return;

          }

          $('#uk-calls-container').next('div.uk-calls-fees').empty().append(
            '<div style="float:none;margin:0 auto;font-size:20px;" class="overlay">' +
              '<div class="spinner-outer">' +
                '<span style="background-color: transparent;" class="fa fa-spinner fa-spin spinner"></span>' +
              '</div>' +
            '</div>'
          );

          /*$.get('/call-rates/search-from-spreadsheet',
            {
              'value': encodeURI($("#uk-calls-input").val()),
              'tab': 0
            })
            .done(function(response){

              if ($.isEmptyObject(response.response))
              {

                $('#uk-calls-container').next('div.uk-calls-fees').empty().append(

                  "<div class='col-sm-12' style='text-align:center;'>" + 

                    "<label>Nothing was found.</label>" + 

                  "</div>"

                );

              }

              else
              {

                let row = '',
                  html = 

                  "<table class='top-20-destinations' aria-describedby='callcharges'>" +

                    "<thead>" +

                      "<tr>" +

                        "<td>Code String</td>" +

                        "<td>Name</td>" +

                        "<td>Call Setup Fee</td>" +

                        "<td>Peak Per Minute</td>" +

                        "<td>Offpeak Per Minute</td>" +

                        "<td>Weekend Per Minute</td>" +

                      "</tr>" +

                    "</thead>" +

                    "<tbody>";

                for (var i = 0; i < response.response.length; i++)
                {

                  row = response.response[i]

                  html += "<tr>" +

                            "<td>" + row.code_string + "</td>" +

                            "<td>" + row.name + "</td>" +

                            "<td>" + row.call_setup_fee + "</td>" +

                            "<td>" + row.peak_per_min + "</td>" +

                            "<td>" + row.offpeak_per_min + "</td>" +

                            "<td>" + row.weekend_per_min + "</td>" +

                          "</tr>";

                }

                html += "</body></table>";

                $('#uk-calls-container').next('div.uk-calls-fees').empty().append(html);

              }

            }
          );

        });*/

        $("#other-calls-input").on('keypress', function (event) {

          var keycode = (event.keyCode ? event.keyCode : event.which);

          if(keycode == '13')
          {
            $('#other-calls-container span').trigger('click');
          }

        });

        // Other Calls click event
        $('#other-calls-container span').on('click', function() {

          if ($("#other-calls-input").val() == '') {

            $('#other-calls-container').next('div.other-calls-fees').empty();

            return;

          }

          $('#other-calls-container').next('div.other-calls-fees').empty().append(
            '<div style="float:none;margin:0 auto;font-size:20px;" class="overlay">' +
              '<div class="spinner-outer">' +
                '<span style="background-color: transparent;" class="fa fa-spinner fa-spin spinner"></span>' +
              '</div>' +
            '</div>'
          );

          /*$.get('/call-rates/search-from-spreadsheet',
            {
              'value': encodeURI($("#other-calls-input").val()),
              'tab': 1
            })
            .done(function(response){

              if ($.isEmptyObject(response.response))
              {

                $('#other-calls-container').next('div.other-calls-fees').empty().append(

                  "<div class='col-sm-12' style='text-align:center;'>" + 

                    "<label>Nothing was found.</label>" + 

                  "</div>"

                );

              }

              else
              {

                let row = '',
                  html = 

                  "<table class='top-20-destinations' aria-describedby='callcharges'>" +

                    "<thead>" +

                      "<tr>" +

                        "<td>Code String</td>" +

                        "<td>Name</td>" +

                        "<td>Access Charge Per Minute</td>" +

                        "<td>Service Charge Per Minute</td>" +

                        "<td>Service Charge Per Call</td>" +

                      "</tr>" +

                    "</thead>" +

                    "<tbody>";

                for (var i = 0; i < response.response.length; i++)
                {

                  row = response.response[i]

                  html += "<tr>" +

                            "<td>" + row.code_string + "</td>" +

                            "<td>" + row.name + "</td>" +

                            "<td>" + row.access_charge_per_minute + "</td>" +

                            "<td>" + row.service_charge_per_minute + "</td>" +

                            "<td>" + row.service_charge_per_call + "</td>" +

                          "</tr>";

                }

                html += "</body></table>";

                $('#other-calls-container').next('div.other-calls-fees').empty().append(html);

              }

          });*/

        });

        $("#international-calls-input").on('keypress', function (event) {

          var keycode = (event.keyCode ? event.keyCode : event.which);

          if(keycode == '13')
          {
            $('#international-calls-container span').trigger('click');
          }

        });
        /*
        // International Calls click event
        $('#international-calls-container span').on('click', function() {

          if ($("#international-calls-input").val() == '') {

            $('#international-calls-container').next('div.row').empty();

            return;

          }

          $('#international-calls-container').next('div.row').empty().append(
            '<div style="float:none;margin:0 auto;font-size:20px; text-align: center" class="overlay">' +
              '<div class="spinner-outer">' +
                '<p>Retrieving Data</p>' +
                '<span style="background-color: transparent;" class="fa fa-spinner fa-spin spinner"></span>' +
              '</div>' +
            '</div>'
          );

          $.get('/call-rates/search-from-spreadsheet',
            {
              'value': encodeURI($("#international-calls-input").val()),
              'tab': 2
            },
            function(response){

              if ($.isEmptyObject(response.response))
              {

                $('#international-calls-container').next('div.row').empty().append(

                  "<div class='col-sm-12' style='text-align:center;'>" + 

                    "<label>Nothing was found.</label>" + 

                  "</div>"

                );

              }

              else
              {

                let html = 

                  "<table class='top-20-destinations' aria-describedby='callcharges'>" +

                    "<thead>" +

                      "<tr>" +

                        "<td></td>" +

                        "<td>Destination</td>" +

                        "<td>Price per minute</td>" +

                        "<td>Call setup charge</td>" +

                      "</tr>" +

                    "</thead>" +

                    "<tbody>";

                      for (var i = 0; i < response.response.length; i++)
                      {
                        html += "<tr>" +

                                  "<td>" + response.response[i]['gamma_destination'] + "</td>" +

                                  "<td>" + response.response[i]['destination'] + "</td>" +

                                  "<td>" + (isNaN(response.response[i]['price_per_minute']) || !response.response[i]['price_per_minute'] ? '-' : response.response[i]['price_per_minute'] + 'p') + "</td>" +

                                  "<td>" + (isNaN(response.response[i]['call_setup_fee']) || !response.response[i]['call_setup_fee'] ? '-' : response.response[i]['call_setup_fee'] + 'p') + "</td>" +

                                "</tr>";
                      }

                    html += 
                    "</tbody>" +

                  "</table>";

                $('#international-calls-container').next('div.row').empty().append(html);

              }

          });*/

        });

    },

    preloadInternationalCallsTab: function() {

      // Using -1 to denote we want to pre-load international calls with top 20
      /*$.get('/call-rates/search-from-spreadsheet',
        {
          'value': encodeURI($("#international-calls-input").val()),
          'tab': -1
        },
        function(response) {

          let html = "<h2>Top 20 Destinations</h2>" +
          
                    "<table class='top-20-destinations' aria-describedby='callcharges'>" +

                      "<thead>" +

                        "<tr>" +

                          "<td>Destination</td>" +

                          "<td>Price per Minute</td>" +

                          "<td>Call Setup Fee</td>" +

                        "</tr>" +

                      "</thead>" +

                      "<tbody>";

          let res = response.response;

          for(var key in res)
          {
            html += "<tr>" +
                      "<td>" + res[key]['destination'] + "</td>" +
                      "<td>" + (isNaN(res[key]['price_per_minute']) || !res[key]['price_per_minute'] ? '-' : res[key]['price_per_minute'] + 'p') + "</td>" +
                      "<td>" + (isNaN(res[key]['call_setup_fee']) || !res[key]['call_setup_fee'] ? '-' : res[key]['call_setup_fee'] + 'p') + "</td>" +
                    "</tr>";
          }

          html += "</tbody></table>";

          $('#international-calls-container').show().next('div.row').empty().append(html);

        }
      );*/

    },

    populateCallData: function(r) {

        var html =  '<p><strong data-toggle="tooltip" data-placement="top" title="The telephone number type, category or destination dialled.">Destination <img src="/includes/assets/images/tooltip.png">: </strong>' + r.data.description + '</p>';
            html += '<p><strong data-toggle="tooltip" data-placement="top" title="The minimum cost of the call, irrespective of how long the call is.">Minimum charge <img src="/includes/assets/images/tooltip.png">: </strong><span>' + this.formatPrice(r.data.minimum_charge) + '</span></p>';
            html += '<p><strong data-toggle="tooltip" data-placement="top" title="Calls made Monday to Friday 8am-6pm, expressed as the connection charge plus the pence per minute thereafter.">Daytime <img src="/includes/assets/images/tooltip.png"></strong>: <span>' + this.formatPrice(r.data.on_peak) + ' + ' + this.formatPrice(r.data.on_peak_connection_charge) + ' connection charge</span>';
            html += '<p><strong data-toggle="tooltip" data-placement="top" title="Calls made Monday to Friday 6pm-8am, expressed as the connection charge plus the pence per minute thereafter.">Evening <img src="/includes/assets/images/tooltip.png"></strong>: <span>' + this.formatPrice(r.data.off_peak) + '+ ' + this.formatPrice(r.data.off_peak_connection_charge) + ' connection charge</span>';
            html += '<p><strong data-toggle="tooltip" data-placement="top" title="Calls made 12am Saturday to 12am Monday, expressed as the connection charge plus the pence per minute thereafter.">Weekend <img src="/includes/assets/images/tooltip.png"></strong>: <span>' + this.formatPrice(r.data.weekend) + ' + ' + this.formatPrice(r.data.weekend_connection_charge) + ' connection charge</span>';
            html += '<p><strong data-toggle="tooltip" data-placement="top" title="Any charge made by the receiving caller\'s telephone provider - added to the total cost of the call.">Access Charge <img src="/includes/assets/images/tooltip.png">:</strong> <span>' + this.formatPrice(r.data.access_charge) + '</span>';

        $(".voice-network-country-costs > div").html(html);

        $('#voice-network-country-costs > div').addClass('hidden');

        $('#voice-network-country-costs input').val('');

        $('[data-toggle="tooltip"]').tooltip()

    },

    formatPrice: function(price) {

        return accounting.formatMoney(price, { symbol: "£", precision: 2, thousand: ".", decimal: "." })

    },

    footerForm: function() {

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        $('.contact-form input, .contact-form textarea').keyup(function() {

            if ( $('#name').val() != '' && re.test(String($('#email').val()).toLowerCase()) && $('#message').val() != '' ) {

                $('.g-recaptcha').removeClass('disabled')

            } else {

                $('.g-recaptcha').addClass('disabled')

            }

        });

        $('.contact-form').parent().not('.js').submit(function(e){

            e.preventDefault()

            $('.contact-form').parent().addClass('js')

			//if ($('#ContactFormFooter')[0].reportValidity()) {

	            $.ajax({
	              type: "POST",
	              url: '/contact-form/footer',
	              data: $('.contact-form').parent().serialize(),
	              success: function(data)
	              {
	                if ( data.success ) {
	
	                    $('.contact-form').parent()[0].reset()
	
	                    APPLICATION._APPLICATION.fireModal('/modals/modal_thank_you_contact_form', 'Modals', 'modal_thank_you_contact_form');
	
	                } else {
	
	                    APPLICATION._APPLICATION.fireModal('/modals/error_contact_form', 'Modals', 'error_contact_form');
	
	                }
	
	                grecaptcha.reset()
	
	                $('.g-recaptcha').addClass('disabled')
	
	              },
	              error: function (xhr, ajaxOptions, thrownError) {
	                  console.log(xhr)
	                  console.log(ajaxOptions)
	                  console.log(thrownError)
	                }
	            });
            
	        //}


        })

    },

    wholesaleForm: function() {

      $('.wholesale-form').not('.js').submit(function(e){
        e.preventDefault()
        $.ajax({
          type: "POST",
          url: '/contact-form/wholesale/',
          data: $('.wholesale-form').serialize(),
          success: function(data) {
            if ( data.success ) {
              $('.wholesale-form')[0].reset()
              APPLICATION._APPLICATION.fireModal('/modals/modal_wholesale_thank_you', 'Modals', 'modal_wholesale_thank_you');
            } else {
              APPLICATION._APPLICATION.fireModal('/modals/error_wholesale_form', 'Modals', 'error_wholesale_form');
              if (typeof document.createElement( 'input' ).reportValidity == 'function') {
                $('.wholesale-form')[0].reportValidity()
              }
            }
            grecaptcha.reset()
          }
        });
      }).addClass('js')

    },
    
    complaintForm: function() {

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        $('.complaint-form input, .complaint-form textarea').keyup(function() {

            if ( $('#first_name').val() != '' && re.test(String($('#email_address').val()).toLowerCase()) && $('#details').val() != '' ) {

                $('.g-recaptcha').removeClass('disabled')

            } else {

                $('.g-recaptcha').addClass('disabled')

            }

        });

        $('.complaint-form').parent().not('.js').submit(function(e){

            e.preventDefault()

            $('.complaint-form').parent().addClass('js')

			// Trigger html 5 validation
            //if ($('#ComplaintForm')[0].reportValidity()) {

	            $.ajax({
	              type: "POST",
	              url: '/complaint-form/footer',
	              data: $('.complaint-form').parent().serialize(),
	              success: function(data)
	              {
		              
	                if ( data.success ) {
	
	                    $('.complaint-form').parent()[0].reset()
	
	                    APPLICATION._APPLICATION.fireModal('/modals/modal_thank_you_contact_form', 'Modals', 'modal_thank_you_contact_form');
	
	                } else {
	
	                    APPLICATION._APPLICATION.fireModal('/modals/error_contact_form', 'Modals', 'error_contact_form');
	
	                }
	
	                grecaptcha.reset()
	
	                $('.g-recaptcha').addClass('disabled')
	
	              },
	              error: function (xhr, ajaxOptions, thrownError) {
	                  console.log(xhr)
	                  console.log(ajaxOptions)
	                  console.log(thrownError)
	                }
	            });
			
			//}

        })

    },
    
    troublePayingForm: function() {

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        $('.trouble-paying-form input, .trouble-paying-form textarea').keyup(function() {

            if ( $('#first_name').val() != '' && re.test(String($('#email_address').val()).toLowerCase()) && $('#details').val() != '' ) {

                $('.g-recaptcha').removeClass('disabled')

            } else {

                $('.g-recaptcha').addClass('disabled')

            }

        });

        $('.trouble-paying-form').parent().not('.js').submit(function(e){

            e.preventDefault()

            $('.trouble-paying-form').parent().addClass('js')

			// Trigger html 5 validation
            //if ($('#TroublePayingForm')[0].reportValidity()) {

	            $.ajax({
	              type: "POST",
	              url: '/trouble-paying-form/footer',
	              data: $('.trouble-paying-form').parent().serialize(),
	              success: function(data)
	              {
		              
	                if ( data.success ) {
	
	                    $('.trouble-paying-form').parent()[0].reset()
	
	                    APPLICATION._APPLICATION.fireModal('/modals/modal_thank_you_contact_form', 'Modals', 'modal_thank_you_contact_form');
	
	                } else {
	
	                    APPLICATION._APPLICATION.fireModal('/modals/error_contact_form', 'Modals', 'error_contact_form');
	
	                }
	
	                grecaptcha.reset()
	
	                $('.g-recaptcha').addClass('disabled')
	
	              },
	              error: function (xhr, ajaxOptions, thrownError) {
	                  console.log(xhr)
	                  console.log(ajaxOptions)
	                  console.log(thrownError)
	                }
	            });
			
			//}

        })

    },


    cookieBar: function() {

      $(document).ready(function(){
         $.cookieBar({
            policyButton: true,
            policyText: 'Cookie Policy',
            policyURL: '/privacy#cookie_privacy',
         });
      });

    },

    showHiddenDials: function() {

        $('.showHiddenDials').click(function(){

            $('.dial-comparison__hidden-dials').toggleClass('active');
            $(this).toggleClass('active');

            if ( $(this).hasClass('active') ) {
                $(this).text('Hide Long Downloads');
            } else {
                $(this).text('Show Long Downloads');
            }

        });

    },

    loadChart: () => {

        let objTimes = [
            {
              t: 'videogame',
              times: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
            },

            {
              t: 'FHDM',
              times: ['0', '20', '40', '60', '80', '100', '120', '140']
            },

            {
              t: 'HRTV',
              times: ['0', '2', '4', '6', '8', '10', '12', '14']
            }
        ]

        for (let i = 0, l = objTimes.length; i < l; i++) {

            let obtype = objTimes[i].t;
            let obtimes = objTimes[i].times;


            //console.log(i)

            let ctype = $('.chart-container').attr('type');

            if( ctype == obtype ) {

                if( ctype != 'videogame' ){
                    obtimes.forEach( (p) => {
                        $('.chart-time').prepend('<div class="time-item">' + p + ' Mins</div>');
                    });
                } else {
                    obtimes.forEach( (p) => {
                        $('.chart-time').prepend('<div class="time-item">' + p + ' Hours</div>');
                    });
                }
            }
        }

        let ct = $('.chart-container').attr('type');

        if( ct == 'videogame' ){
            $('.bar-1 .bar-popover').html('<p>11 Minutes</p>');
            $('.bar-2 .bar-popover').html('<p>21 Minutes 45 Seconds</p>');
            $('.bar-3 .bar-popover').html('<p>43 Minutes 45 Seconds</p>');
            $('.bar-4 .bar-popover').html('<p>1 Hour 17 Minutes</p>');
            $('.bar-5 .bar-popover').html('<p>2 Hours 40 Minutes</p>');
        } else if ( ct == 'FHDM' ) {
            $('.bar-1 .bar-popover').html('<p>3 Minutes 25 Seconds</p>');
            $('.bar-2 .bar-popover').html('<p>6 Minutes 30 Seconds</p>');
            $('.bar-3 .bar-popover').html('<p>13 Minutes</p>');
            $('.bar-4 .bar-popover').html('<p>23 Minutes</p>');
            $('.bar-5 .bar-popover').html('<p>48 Minutes</p>');
        } else if ( ct == 'HRTV' ) {
            $('.bar-1 .bar-popover').html('<p>17.7 Seconds</p>');
            $('.bar-2 .bar-popover').html('<p>35.5 Seconds</p>');
            $('.bar-3 .bar-popover').html('<p>1 Minute 11 Seconds</p>');
            $('.bar-4 .bar-popover').html('<p>1 Minutes 58.5 Seconds</p>');
            $('.bar-5 .bar-popover').html('<p>4 Minutes 7 Seconds</p>');
        }
    },

    changeChart: () => {
        $('.chart-selector').on('change', (e) => {
            let s = $('.chart-selector').find(':selected').attr('value');
            $('.chart-container').removeAttr('type');
            $('.chart-container').attr('type', s);
            $('.time-item').remove();
            $('.bar-popover p').remove();

            APPLICATION.Global.loadChart();

        });
    },


    reviewPopup: () => {

      $('.button--leave-a-review').click(function(e) {

          e.stopImmediatePropagation();

          e.preventDefault()

          $('body').append(function(){

              var HTML = '<div class="modal show modal--review-prompt">'
                  HTML += '<div class="modal-dialog" role="document">'
                  HTML += '<div class="modal-content">'
                  HTML += '<img src="/includes/assets/images/review_prompt.jpg" />'
                  HTML += '<div class="review-prompt-countdown">Redirecting in <span>8</span></div>'
                  HTML += '<a href="javascript:;" class="button">Go</a>'
                  HTML += '</div></div></div>'

              return HTML

          }).promise().done(function(){

            APPLICATION.Global.reviewsCountdown()

            $('.modal--review-prompt').click(function(){

                window.location.href = $(e.target).attr('href')

            })

          })

        });
        
       if ($('.review-prompt-inline').length) {

            APPLICATION.Global.reviewsCountdown();
        }

    },

    reviewsCountdown: () => {
      
      var i = 30,
          countdown = function countdown() {

          i--;

          $('.review-prompt-countdown > span').html(i);

          if (i > 1) {
              setTimeout(countdown, 1000);
          } else {
              setTimeout(function () {
                  window.location.href = 'https://uk.trustpilot.com/';
              }, 1000);
          }
      };

      countdown();
  },

    
    accordion: function() {

      /*
      *   This content is licensed according to the W3C Software License at
      *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
      *
      *   Simple accordion pattern example
      */

      Array.prototype.slice.call(document.querySelectorAll('.Accordion')).forEach(function (accordion) {

        // Allow for multiple accordion sections to be expanded at the same time
        var allowMultiple = accordion.hasAttribute('data-allow-multiple');
        // Allow for each toggle to both open and close individually
        var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

        // Create the array of toggle elements for the accordion group
        var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-trigger'));
        var panels = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-panel'));


        accordion.addEventListener('click', function (event) {
          var target = event.target;

          if (target.classList.contains('Accordion-trigger')) {
            // Check if the current toggle is expanded.
            var isExpanded = target.getAttribute('aria-expanded') == 'true';
            var active = accordion.querySelector('[aria-expanded="true"]');

            // without allowMultiple, close the open accordion
            if (!allowMultiple && active && active !== target) {
              // Set the expanded state on the triggering element
              active.setAttribute('aria-expanded', 'false');
              // Hide the accordion sections, using aria-controls to specify the desired section
              document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');

              // When toggling is not allowed, clean up disabled state
              if (!allowToggle) {
                active.removeAttribute('aria-disabled');
              }
            }

            if (!isExpanded) {
              // Set the expanded state on the triggering element
              target.setAttribute('aria-expanded', 'true');
              // Hide the accordion sections, using aria-controls to specify the desired section
              document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

              // If toggling is not allowed, set disabled state on trigger
              if (!allowToggle) {
                target.setAttribute('aria-disabled', 'true');
              }
            }
            else if (allowToggle && isExpanded) {
              // Set the expanded state on the triggering element
              target.setAttribute('aria-expanded', 'false');
              // Hide the accordion sections, using aria-controls to specify the desired section
              document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
            }

            event.preventDefault();
          }
        });

        // Bind keyboard behaviors on the main accordion container
        accordion.addEventListener('keydown', function (event) {
          var target = event.target;
          var key = event.which.toString();

          var isExpanded = target.getAttribute('aria-expanded') == 'true';
          var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

          // 33 = Page Up, 34 = Page Down
          var ctrlModifier = (event.ctrlKey && key.match(/33|34/));

          // Is this coming from an accordion header?
          if (target.classList.contains('Accordion-trigger')) {
            // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
            // 38 = Up, 40 = Down
            if (key.match(/38|40/) || ctrlModifier) {
              var index = triggers.indexOf(target);
              var direction = (key.match(/34|40/)) ? 1 : -1;
              var length = triggers.length;
              var newIndex = (index + length + direction) % length;

              triggers[newIndex].focus();

              event.preventDefault();
            }
            else if (key.match(/35|36/)) {
              // 35 = End, 36 = Home keyboard operations
              switch (key) {
                // Go to first accordion
                case '36':
                  triggers[0].focus();
                  break;
                  // Go to last accordion
                case '35':
                  triggers[triggers.length - 1].focus();
                  break;
              }
              event.preventDefault();

            }

          }
        });

        // These are used to style the accordion when one of the buttons has focus
        accordion.querySelectorAll('.Accordion-trigger').forEach(function (trigger) {

          trigger.addEventListener('focus', function (event) {
            accordion.classList.add('focus');
          });

          trigger.addEventListener('blur', function (event) {
            accordion.classList.remove('focus');
          });

        });

        // Minor setup: will set disabled state, via aria-disabled, to an
        // expanded/ active accordion which is not allowed to be toggled close
        if (!allowToggle) {
          // Get the first expanded/ active accordion
          var expanded = accordion.querySelector('[aria-expanded="true"]');

          // If an expanded/ active accordion is found, disable
          if (expanded) {
            expanded.setAttribute('aria-disabled', 'true');
          }
        }

      });

    },
    
    videoTabs: function() {
    	    	
    	$('.video-button').on('keypress click', function(){
			var target = $(this).attr('data-name');
			$('.video-button').not($(this)).removeClass('active');
			$(this).addClass('active');
			if(target == 'all'){
				$('.developer-video-section').show().attr('aria-hidden', 'false');
			} else{
				$('.developer-video-section').not('.'+target).hide().attr('aria-hidden', 'true');
				$('.developer-video-section.'+target).show().attr('aria-hidden', 'false');
			}
			
		});	
    
    },
    
    speedTabs: function() {
	
      if (document.querySelectorAll('[role="tablist"]').length == 0) return;

	  var tablist = document.querySelectorAll('[role="tablist"]')[0];
	  var tabs;
	  var panels;
	  var delay = determineDelay();
	
	  generateArrays();
	
	  function generateArrays () {
	    tabs = document.querySelectorAll('[role="tab"]');
	    panels = document.querySelectorAll('[role="tabpanel"]');
	  };
	
	  // For easy reference
	  var keys = {
	    end: 35,
	    home: 36,
	    left: 37,
	    up: 38,
	    right: 39,
	    down: 40,
	    delete: 46
	  };
	
	  // Add or substract depending on key pressed
	  var direction = {
	    37: -1,
	    38: -1,
	    39: 1,
	    40: 1
	  };
	
	  // Bind listeners
	  for (i = 0; i < tabs.length; ++i) {
	    addListeners(i);
	  };
	
	  function addListeners (index) {
	    tabs[index].addEventListener('click', clickEventListener);
	    tabs[index].addEventListener('keydown', keydownEventListener);
	    tabs[index].addEventListener('keyup', keyupEventListener);
	
	    // Build an array with all tabs (<button>s) in it
	    tabs[index].index = index;
	  };
	
	  // When a tab is clicked, activateTab is fired to activate it
	  function clickEventListener (event) {
	    var tab = event.currentTarget;
	    activateTab(tab, false);
	    
	  };
	
	  // Handle keydown on tabs
	  function keydownEventListener (event) {
	    var key = event.keyCode;
	
	    switch (key) {
	      case keys.end:
	        event.preventDefault();
	        // Activate last tab
	        activateTab(tabs[tabs.length - 1]);
	        break;
	      case keys.home:
	        event.preventDefault();
	        // Activate first tab
	        activateTab(tabs[0]);
	        break;
	
	      // Up and down are in keydown
	      // because we need to prevent page scroll >:)
	      case keys.up:
	      case keys.down:
	        determineOrientation(event);
	        break;
	    };
	  };
	
	  // Handle keyup on tabs
	  function keyupEventListener (event) {
	    var key = event.keyCode;
	
	    switch (key) {
	      case keys.left:
	      case keys.right:
	        determineOrientation(event);
	        break;
	      case keys.delete:
	        determineDeletable(event);
	        break;
	    };
	  };
	
	  // When a tablist's aria-orientation is set to vertical,
	  // only up and down arrow should function.
	  // In all other cases only left and right arrow function.
	  function determineOrientation (event) {
	    var key = event.keyCode;
	    var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
	    var proceed = false;
	
	    if (vertical) {
	      if (key === keys.up || key === keys.down) {
	        event.preventDefault();
	        proceed = true;
	      };
	    }
	    else {
	      if (key === keys.left || key === keys.right) {
	        proceed = true;
	      };
	    };
	
	    if (proceed) {
	      switchTabOnArrowPress(event);
	    };
	  };
	
	  // Either focus the next, previous, first, or last tab
	  // depening on key pressed
	  function switchTabOnArrowPress (event) {
	    var pressed = event.keyCode;
	
	    for (x = 0; x < tabs.length; x++) {
	      tabs[x].addEventListener('focus', focusEventHandler);
	    };
	
	    if (direction[pressed]) {
	      var target = event.target;
	      if (target.index !== undefined) {
	        if (tabs[target.index + direction[pressed]]) {
	          tabs[target.index + direction[pressed]].focus();
	        }
	        else if (pressed === keys.left || pressed === keys.up) {
	          focusLastTab();
	        }
	        else if (pressed === keys.right || pressed == keys.down) {
	          focusFirstTab();
	        };
	      };
	    };
	  };
	
	  // Activates any given tab panel
	  function activateTab (tab, setFocus) {
	    setFocus = setFocus || true;
	    // Deactivate all other tabs
	    deactivateTabs();
	
	    // Remove tabindex attribute
	    tab.removeAttribute('tabindex');
	
	    // Set the tab as selected
	    tab.setAttribute('aria-selected', 'true');
	
	    // Get the value of aria-controls (which is an ID)
	    var controls = tab.getAttribute('aria-controls');
	
	    // Remove hidden attribute from tab panel to make it visible
	    document.getElementById(controls).removeAttribute('hidden');
	
	    // Set focus when required
	    if (setFocus) {
	      tab.focus();
	    };
	  };
	
	  // Deactivate all tabs and tab panels
	  function deactivateTabs () {
	    for (t = 0; t < tabs.length; t++) {
	      tabs[t].setAttribute('tabindex', '-1');
	      tabs[t].setAttribute('aria-selected', 'false');
	      tabs[t].removeEventListener('focus', focusEventHandler);
	    };
	
	    for (p = 0; p < panels.length; p++) {
	      panels[p].setAttribute('hidden', 'hidden');
	    };
	  };
	
	  // Make a guess
	  function focusFirstTab () {
	    tabs[0].focus();
	  };
	
	  // Make a guess
	  function focusLastTab () {
	    tabs[tabs.length - 1].focus();
	  };
	
	  // Detect if a tab is deletable
	  function determineDeletable (event) {
	    target = event.target;
	
	    if (target.getAttribute('data-deletable') !== null) {
	      // Delete target tab
	      deleteTab(event, target);
	
	      // Update arrays related to tabs widget
	      generateArrays();
	
	      // Activate the closest tab to the one that was just deleted
	      if (target.index - 1 < 0) {
	        activateTab(tabs[0]);
	      }
	      else {
	        activateTab(tabs[target.index - 1]);
	      };
	    };
	  };
	
	  // Deletes a tab and its panel
	  function deleteTab (event) {
	    var target = event.target;
	    var panel = document.getElementById(target.getAttribute('aria-controls'));
	
	    target.parentElement.removeChild(target);
	    panel.parentElement.removeChild(panel);
	  };
	
	  // Determine whether there should be a delay
	  // when user navigates with the arrow keys
	  function determineDelay () {
	    var hasDelay = tablist.hasAttribute('data-delay');
	    var delay = 0;
	
	    if (hasDelay) {
	      var delayValue = tablist.getAttribute('data-delay');
	      if (delayValue) {
	        delay = delayValue;
	      }
	      else {
	        // If no value is specified, default to 300ms
	        delay = 300;
	      };
	    };
	
	    return delay;
	  };
	
	  //
	  function focusEventHandler (event) {
	    var target = event.target;
	
	    setTimeout(checkTabFocus, delay, target);
	  };
	
	  // Only activate tab on focus if it still has focus after the delay
	  function checkTabFocus (target) {
	    focused = document.activeElement;
	
	    if (target === focused) {
	      activateTab(target, false);
	    };
	  };

	
			
	},

    isTouch: function() {

        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function(query) {
            return window.matchMedia(query).matches;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);

    },
    
    dropdownMenu: function() {
		
		var keyCodeMap = {
		        48:"0", 49:"1", 50:"2", 51:"3", 52:"4", 53:"5", 54:"6", 55:"7", 56:"8", 57:"9", 59:";",
		        65:"a", 66:"b", 67:"c", 68:"d", 69:"e", 70:"f", 71:"g", 72:"h", 73:"i", 74:"j", 75:"k", 76:"l",
		        77:"m", 78:"n", 79:"o", 80:"p", 81:"q", 82:"r", 83:"s", 84:"t", 85:"u", 86:"v", 87:"w", 88:"x", 89:"y", 90:"z",
		        96:"0", 97:"1", 98:"2", 99:"3", 100:"4", 101:"5", 102:"6", 103:"7", 104:"8", 105:"9"
		}
		
	
		
			var settings = jQuery.extend({
				menuHoverClass: 'show-menu',
			}, settings);
			
			// Add ARIA role to menubar and menu items
			$('.top-nav').attr('role', 'menubar').find('li').attr('role', 'menuitem');
			
			var top_level_links = $('.top-nav').find('> li > a');
					
			// Set tabIndex to -1 so that top_level_links can't receive focus until menu is open
			$(top_level_links).next('ul')
				.attr('data-test','true')
				.attr({ 'aria-hidden': 'true', 'role': 'menu' })
				.find('a')
				.attr('tabIndex',-1);
			
			// Adding aria-haspopup for appropriate items
			$(top_level_links).each(function(){
				if($(this).next('ul').length > 0)
					$(this).parent('li').attr('aria-haspopup', 'true');
			});
			
			$(top_level_links).hover(function(){
				$(this).closest('ul') 
					.attr('aria-hidden', 'false')
					.find('.'+settings.menuHoverClass)
					.attr('aria-hidden', 'true')
					.removeClass(settings.menuHoverClass)
					.find('a')
					.attr('tabIndex',-1);
				$(this).next('ul')
					.attr('aria-hidden', 'false')
					.addClass(settings.menuHoverClass)
					.find('a').attr('tabIndex',0);
			});
		
		  $(top_level_links).focus(function(){
				$(this).closest('ul')
					.find('.'+settings.menuHoverClass)
					.attr('aria-hidden', 'true')
					.removeClass(settings.menuHoverClass)
					.find('a')
					.attr('tabIndex',-1);
				
		    $(this).next('ul')
					.attr('aria-hidden', 'false')
					.addClass(settings.menuHoverClass)
					.find('a').attr('tabIndex',0);
			});
			
			
			// Bind arrow keys for navigation
			$(top_level_links).keydown(function(e){
				if(e.keyCode == 37) {
					e.preventDefault();
					// This is the first item
					if($(this).parent('li').prev('li').length == 0) {
						$(this).parents('ul').find('> li').last().find('a').first().focus();
					} else {
						$(this).parent('li').prev('li').find('a').first().focus();
					}
				} else if(e.keyCode == 38) {
					e.preventDefault();
					if($(this).parent('li').find('ul').length > 0) {
						$(this).parent('li').find('ul')
							.attr('aria-hidden', 'false')
							.addClass(settings.menuHoverClass)
							.find('a').attr('tabIndex',0)
							.last().focus();
					}
				} else if(e.keyCode == 39) {
					e.preventDefault();
					// This is the last item
					if($(this).parent('li').next('li').length == 0) {
						$(this).parents('ul').find('> li').first().find('a').first().focus();
					} else {
						$(this).parent('li').next('li').find('a').first().focus();
					}
				} else if(e.keyCode == 40) {
					e.preventDefault();
					if($(this).parent('li').find('ul').length > 0) {
						$(this).parent('li').find('ul')
							.attr('aria-hidden', 'false')
							.addClass(settings.menuHoverClass)
							.find('a').attr('tabIndex',0)
							.first().focus();
					}
				} else if(e.keyCode == 13 || e.keyCode == 32) {
					// If submenu is hidden, open it
					e.preventDefault();
					$(this).parent('li').find('ul[aria-hidden=true]')
							.attr('aria-hidden', 'false')
							.addClass(settings.menuHoverClass)
							.find('a').attr('tabIndex',0)
							.first().focus();
				} else if(e.keyCode == 27) {
					e.preventDefault();
					$('.'+settings.menuHoverClass)
						.attr('aria-hidden', 'true')
						.removeClass(settings.menuHoverClass)
						.find('a')
						.attr('tabIndex',-1);
				} else {
					$(this).parent('li').find('ul[aria-hidden=false] a').each(function(){
						if($(this).text().substring(0,1).toLowerCase() == keyCodeMap[e.keyCode]) {
							$(this).focus();
							return false;
						}
					});
				}
			});
			
			
			var links = $(top_level_links).parent('li').find('ul').find('a');
			$(links).keydown(function(e){
				if(e.keyCode == 38) {
					e.preventDefault();
					// This is the first item
					if($(this).parent('li').prev('li').length == 0) {
						$(this).parents('ul').parents('li').find('a').first().focus();
					} else {
						$(this).parent('li').prev('li').find('a').first().focus();
					}
				} else if(e.keyCode == 40) {
					e.preventDefault();
					if($(this).parent('li').next('li').length == 0) {
						$(this).parents('ul').parents('li').find('a').first().focus();
					} else {
						$(this).parent('li').next('li').find('a').first().focus();
					}
				} else if(e.keyCode == 27 || e.keyCode == 37) {
					e.preventDefault();
					$(this)
						.parents('ul').first()
							.prev('a').focus()
							.parents('ul').first().find('.'+settings.menuHoverClass)
							.attr('aria-hidden', 'true')
							.removeClass(settings.menuHoverClass)
							.find('a')
							.attr('tabIndex',-1);
				} else if(e.keyCode == 32) {
					e.preventDefault();
					window.location = $(this).attr('href');
				} else {
					var found = false;
					$(this).parent('li').nextAll('li').find('a').each(function(){
						if($(this).text().substring(0,1).toLowerCase() == keyCodeMap[e.keyCode]) {
							$(this).focus();
							found = true;
							return false;
						}
					});
					
					if(!found) {
						$(this).parent('li').prevAll('li').find('a').each(function(){
							if($(this).text().substring(0,1).toLowerCase() == keyCodeMap[e.keyCode]) {
								$(this).focus();
								return false;
							}
						});
					}
				}
			});
		
				
			
				
			// Hide menu if click or focus occurs outside of navigation
			$('.top-nav').find('a').last().keydown(function(e){ 
				if(e.keyCode == 9) {
					// If the user tabs out of the navigation hide all menus
					$('.'+settings.menuHoverClass)
						.attr('aria-hidden', 'true')
						.removeClass(settings.menuHoverClass)
						.find('a')
						.attr('tabIndex',-1);
				}
			});
		
		  $(document).click(function(){ $('.'+settings.menuHoverClass).attr('aria-hidden', 'true').removeClass(settings.menuHoverClass).find('a').attr('tabIndex',-1); });
			
			$('.top-nav').click(function(e){
				e.stopPropagation();
			});
	    
    },

    menuSearch() {

        let button = document.querySelector('.js-menu-search'),
            input  = document.querySelector('.menu-search input'),
            close  = document.querySelector('.menu-search .fa-times');
        if (!button.classList.contains('js-ignore')) {

            button.addEventListener('click', e => {

                //document.documentElement.classList.toggle('menu-search-active');
                //button.setAttribute('aria-expanded', document.documentElement.classList.contains('menu-search-active'));
                if (!$('.js-menu-search').hasClass('js-menu-search-active'))
                {
                  $('.js-menu-search').addClass('js-menu-search-active');
                  $('.js-menu-search img').addClass('js-menu-search-active-icon')
                } else
                {
                  $('.js-menu-search').removeClass('js-menu-search-active');
                }

                

                
                
                if (!$('.menu-search').hasClass('menu-search-active'))
                {
                  $('.menu-search').addClass('menu-search-active');
                  $('html').addClass('menu-search-active');
                } else
                {
                  $('.menu-search').removeClass('menu-search-active');
                  $('.menu-search').removeClass('menu-search-content');
                  $('html').removeClass('menu-search-active');
                }
                
                if (document.documentElement.classList.contains('menu-search-active')) {
                    input.focus();
                } else {
                    $('.menu-search-results').html('');
                    
                }
                

            });

            button.addEventListener('keydown', e => {

                if (e.keyCode === 13) {
                    document.documentElement.classList.toggle('menu-search-active');
                    button.setAttribute('aria-expanded', document.documentElement.classList.contains('menu-search-active'));
                    if (document.documentElement.classList.contains('menu-search-active')) {
                        input.focus();
                    } else {
                        $('.menu-search-results').html('');
                        $('.menu-search input').val('');
                        $('.menu-search').removeClass('menu-search-content');
                        
                    }
                }

            })

            close.addEventListener('click', e => {

                //document.documentElement.classList.toggle('menu-search-active');
                button.setAttribute('aria-expanded', document.documentElement.classList.contains('menu-search-active'));
                $('.js-menu-search').removeClass('js-menu-search-active');
                
                if (document.documentElement.classList.contains('menu-search-active') && !e.target.classList.contains('fa-times')) {
                    input.focus();
                } else {
                    $('.menu-search-results').html('');
                    $('.menu-search input').val('');
                    $('.menu-search').removeClass('menu-search-content');
                    $('.menu-search').removeClass('menu-search-active');
                    $('html').removeClass('menu-search-active');
                    //$('.menu-search').addClass('menu-search-content');
                }

            });

            $('.menu-search-results').on('change',function()
            {
              if ($('.menu-search-results').is('.empty'))
              {
                $('.menu-search').removeClass('menu-search-content')
              }
            }
            )
            

            close.addEventListener('keydown', e => {

                if (e.keyCode === 13) {
                    document.documentElement.classList.remove('menu-search-active');
                    $('.js-menu-search').removeClass('js-menu-search-active');
                    button.setAttribute('aria-expanded', 'false');
                    $('.menu-search-results').html('');
                    $('.menu-search input').val('');
                    button.focus();
                }

            })

        }

        if (!input.classList.contains('js-ignore')) {

            input.addEventListener('keyup', e => {

                $.get('/search?s=' + encodeURI(e.target.value), (response) => {

                    $('.menu-search-results').html(response);
                    if (!$('.menu-search-results').is(':empty'))
                    {
                      $('.menu-search').addClass('menu-search-content');
                      
                    }
                    else
                    $('.menu-search').removeClass('menu-search-content');

                });

            });

        }
    },

    termsModals() { 
      Array.from(document.querySelectorAll('[data-target^="#terms-"]')).forEach(modal_button => {
        modal_button.addEventListener('click', (e) => {
            _modal.setupModals(
              modal_button.dataset.target.replace('#', ''),
              {
                [modal_button.dataset.target.replace('#', '')]: {
                  display: "flex",
                  colour: "#EBF8FD",
                  auto_height: true,
                  width: "470px",
                  center: true,
                  invertCross: true,
                },
              },
              () => {}
            );
        });
      });
    }

}